import { render, staticRenderFns } from "./widget-poi.vue?vue&type=template&id=5840fdb6"
import script from "./widget-poi.vue?vue&type=script&lang=ts"
export * from "./widget-poi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports